import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { always } from 'ramda';

import {
  AUTHENTICATION_FAILED,
  LOGIN_REQUESTED,
  LOGIN_SUCCEEDED,
  REGISTRATION_SUCCEEDED,
  REGISTRATION_REQUESTED,
} from 'app/features/authentication/actions/actionTypes';

const isLoading = handleActions(
  {
    [LOGIN_REQUESTED]: always(true),
    [LOGIN_SUCCEEDED]: always(false),
    [REGISTRATION_REQUESTED]: always(true),
    [REGISTRATION_SUCCEEDED]: always(false),
    [AUTHENTICATION_FAILED]: always(false),
  },
  false,
);

export { isLoading };

export default combineReducers({ isLoading });
